import { FileActionButton } from "../file-action/file-action-controls";
import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import routeCodeServices from '../../services/route-codes/routecode.service';
import RouteCodeSearch from './route-code-search';
import RouteCodeDataTable from './route-code-datatable';
import { useTranslation } from 'react-i18next';
import { RouteCodeUser1, RoutCodeDTO } from '../../models/route-code/routecode-model';
import { RouteCodeModel } from '../../models/orders/order-list-model';
import AppLoading from '../app-loading/app-loading';
import * as XLSX from 'xlsx'; 

interface FilterParams {
    keyword?: string | null;
    userID?: number | null;
    routeCodeID?: number[] ;
  }

const AssignRouteCode: React.FC = () => {
    const { t } = useTranslation();
    const [userList, setUserList] = useState<RouteCodeUser1[]>([]);
    const [routeCodes, setRouteCodes] = useState<RouteCodeModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);  
    const [pageSize, setPageSize] = useState(10);     
    const [totalRecords, setTotalRecords] = useState(0);
    const [filterParams, setFilterParams] = useState<FilterParams>({});

    useEffect(() => {
        fetchData(pageNumber, pageSize);
        setLoading(true);
    }, []);


    const handleSearch = async (filter: FilterParams) => {
        setPageNumber(1);
        setPageSize(10);
        setFilterParams(filter);
       
        setLoading(true);
        try {
          const response = await routeCodeServices.FilterAssignRouteCode({
            ...filter,
            pageNumber: 1,
            pageSize: 10,
            keyword: filter.keyword || null,
            userID: filter.userID || null,
            routeCodeID: filter.routeCodeID
          });
          setUserList(response.routeCodes);
          setTotalRecords(response.totalRecords);
        } catch (error) {
          console.error("Error searching data:", error);
          setUserList([]);
          setTotalRecords(0);
        } finally {
          setLoading(false);
        }
      };
    //const handleSearch = (query: string): void => {
        // setLoading(true);
        // routeCodeServices.getUsers(query).then((response: any) => {
        //     const sortedData = [...response].sort((a, b) => b.userAddressID - a.userAddressID);
        //     setUserList(sortedData);
        //     setLoading(false);
        // }).catch((error) => {
        //     console.error('Error fetching users:', error);
        //     setLoading(false);
        // });
  //  };

//    const handlePageChange = (event: { first: number, rows: number }) => {
//     let newPageNumber = Math.floor(event.first / event.rows) + 1; 
//     let newPageSize = event.rows;

//     if (event.first + newPageSize >= totalRecords) {
//         newPageNumber = Math.ceil(totalRecords / newPageSize); 
//     }

//     if (event.first === 0) {
//         newPageNumber = 1;
//     }

//     setPageNumber(newPageNumber);
//     setPageSize(newPageSize);
//     fetchData(newPageNumber, newPageSize);
// };

const handlePageChange = async (event: any) => {
    setLoading(true);

    const newPageNumber = Math.floor(event.first / event.rows) + 1;
    const newPageSize = event.rows;
   
    setPageNumber(newPageNumber);
    setPageSize(newPageSize);
   
    try {
      let response;
      if (Object.keys(filterParams).length > 0) {
        response = await routeCodeServices.FilterAssignRouteCode({
          ...filterParams,
          pageNumber: newPageNumber,
          pageSize: newPageSize
        });
      } else {
        response = await routeCodeServices.GetAllAssignRouteCode(newPageNumber, newPageSize);
      }
     
      setUserList(response.routeCodes);
      setTotalRecords(response.totalRecords);
    } catch (error) {
      console.error("Error during page change:", error);
    }finally {
        setLoading(false);
      }
  };
    useEffect(() => {
        
        routeCodeServices.getRouteCodes().then((response) => {
            const result = [{ routeCodeID: 0, name: 'Not Assigned' }, ...response];
            setRouteCodes(result);
        }).catch((error) => {
            console.error('Error fetching route codes:', error);
        });
    }, []);

    const fetchData = async (page: number, size: number) => {
        setLoading(true);
        try {
          const response = await routeCodeServices.GetAllAssignRouteCode(page, size);
          setUserList(response.routeCodes);
          setTotalRecords(response.totalRecords);
            }catch(error)  {
                console.error("Error fetching address data", error);
            }finally {
          setLoading(false);
        }
      };
      const handleUpdate = (updatedList: RouteCodeUser1[]) => {
    setUserList(updatedList);
};

    
    const handleExport = () => {
        const formattedData = userList.map(user => ({
            'Mobile #': user.mobile,
            'User Name': user.userName,
            'Address': user.address,
            'Area': user.area,
            'SubDistrict': user.subDistrict,
            'District': user.district,
            'State': user.state,
            'Route Code': user.routeCodeID
                ? routeCodes.find(route => route.routeCodeID === user.routeCodeID)?.name
                : 'Not Assigned',
        }));

        const ws = XLSX.utils.json_to_sheet(formattedData);

        
        ['A1', 'B1', 'C1', 'D1', 'E1', 'F1'].forEach((cell) => {
            ws[cell] = { t: 's', v: ws[cell]?.v, s: { font: { bold: true } } };
        });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Users');

        XLSX.writeFile(wb, 'Route_Code_Assignment_Report.xlsx');
    };

    const handlePrint = () => {
        const printWindow = window.open('', '', 'height=600,width=800');
    
        if (printWindow) {
            const printableContent = `
                <html>
                    <head><title>Route Code Assignment Report</title></head>
                    <body>
                        <h3>Route Code Assignment Report</h3>
                        <table border="1" cellpadding="5" cellspacing="0">
                            <thead>
                                <tr>
                                    <th>Mobile #</th>
                                    <th>User Name</th>
                                    <th>Address</th>
                                    <th>City</th>
                                    <th>State</th>
                                    <th>Route Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${userList.map(user => `
                                    <tr>
                                        <td>${user.mobile}</td>
                                        <td>${user.userName}</td>
                                        <td>${user.address}</td>
                                        <td>${user.district}</td>
                                        <td>${user.state}</td>
                                        <td>${user.routeCodeID ? routeCodes.find(route => route.routeCodeID === user.routeCodeID)?.name : 'Not Assigned'}</td>
                                    </tr>
                                `).join('')}
                            </tbody>
                        </table>
                    </body>
                </html>
            `;
            printWindow.document.write(printableContent);
            printWindow.document.close();
            printWindow.print();
        } else {
            console.error("Unable to open print window.");
        }
    };

    return (
        <>
            <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
                <div className="col-12">
                    <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                        <h5 className="ml-1 mb-0">{t('assignRouteCode_head')}</h5>
                        <div className="flex align-items-center flex-wrap gap-2">
                            <div className="mr-1">
                                <Button className="text-black border-round mr-2" icon="pi pi-print" severity="secondary" text raised onClick={handlePrint}> Print</Button>
                                <FileActionButton action="export" className="text-black border-round" icon="pi pi-file-export" severity="secondary" text raised onClick={handleExport}> Export</FileActionButton>
                            </div>
                        </div>
                    </div>
                </div>
                <RouteCodeSearch onSearch={handleSearch}  setLoading={setLoading} />
                <RouteCodeDataTable 
               data={userList}
               routeCodes={routeCodes}
               onPageChange={handlePageChange}
               pageNumber={pageNumber}
               pageSize={pageSize}
               totalRecords={totalRecords}
               filterParams={filterParams}
               onUpdate={handleUpdate}
               />
            </div>
            {loading && <AppLoading />}
        </>
    );
};

export default AssignRouteCode;